import { render, staticRenderFns } from "./GIS3DViewer.vue?vue&type=template&id=0b4fa4a8&scoped=true&"
import script from "./GIS3DViewer.vue?vue&type=script&lang=js&"
export * from "./GIS3DViewer.vue?vue&type=script&lang=js&"
import style0 from "./GIS3DViewer.vue?vue&type=style&index=0&id=0b4fa4a8&scoped=true&lang=css&"
import style1 from "./GIS3DViewer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4fa4a8",
  null
  
)

export default component.exports